// extracted by mini-css-extract-plugin
export var breadcrumbs = "styles-module--breadcrumbs--yM4dn";
export var center = "styles-module--center--adbfs";
export var item = "styles-module--item--1vHgm";
export var current = "styles-module--current--zIoei";
export var backAndForthRight = "styles-module--backAndForthRight--xBgrd";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--p-mE1";
export var animateBg = "styles-module--animateBg--6uO0T";